// Module
var code = "<div id=\"V-73491713-9217-4D8D-B8DF-3A7299730944\"> <div data-b-component=\"scroll\" data-b-comp-vertical=\"true\"> <div id=\"V-73491713-9217-4D8D-B8DF-3A7299730944-container\" style=\"direction:ltr;height:100%\"> </div> </div> </div> ";
// Exports
export default code;